export default __webpack_public_path__ + "static/media/Group9260.6a2940b0.svg";